import { bestpark } from './base-api';
import moment from 'moment';
import { API_DATE_FORMAT } from 'constants/date-format';

const getMaxSlot = async (
  key: string,
  parkId: string | undefined,
  startDate: Date | undefined,
): Promise<number> => {
  if (startDate === undefined) return 0;
  const start = moment(startDate).format(API_DATE_FORMAT);
  const result = await bestpark.get(
    `/reservations/max-slot?parkId=${parkId}&startDate=${start}`,
  );
  return result.data;
};

interface PostReservationArgs {
  data: ReservationApiData;
  token: string;
}
const postReservation = async ({
  data,
  token,
}: PostReservationArgs): Promise<Reservation> => {
  const result = await bestpark.post('/reservations', data, {
    Authorization: `Bearer ${token}`,
  });
  return result.data;
};

// This is a refactored endpoint, use this moving forward
interface PostReservationArgs {
  data: ReservationApiData;
  token: string;
}
const createReservation = async ({
  data,
  token,
}: PostReservationArgs): Promise<Reservation> => {
  const result = await bestpark.post('/reservations/admin', data, {
    Authorization: `Bearer ${token}`,
  });
  return result.data;
};

const getReservation = async (
  key: string,
  reservationId: number,
): Promise<Reservation> => {
  const result = await bestpark.get(`/reservations/${reservationId}`);
  return result.data;
};

const updateReservationPayment = (id: string) => async (
  data: ReservationUpdatePaymentData,
): Promise<Reservation> => {
  const result = await bestpark.put(`/reservations/${id}`, data);
  return result.data;
};

const cancelCustomerReservation = async ({
  data,
  token,
}: ReservationCancelData): Promise<Reservation> => {
  const result = await bestpark.put('/reservations/cancel', data, {
    Authorization: `Bearer ${token}`,
  });
  return result.data;
};

export const reservationsApi = {
  getMaxSlot,
  postReservation,
  createReservation,
  getReservation,
  updateReservationPayment,
  cancelCustomerReservation,
};
